// extracted by mini-css-extract-plugin
export default {"Container":"Container_Container__qud7K","Spinner":"Container_Spinner__ck1oZ"};